/**
 * @generated SignedSource<<335f146875c76d9138731d4966af6132>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedEditorialModule_componentModule$data = {
  readonly items: ReadonlyArray<{
    readonly cta: string | null;
    readonly imageUrl: string | null;
    readonly linkData: {
      readonly path: string | null;
    };
    readonly title: string | null;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedEditorialModule_componentModule";
};
export type HpSharedEditorialModule_componentModule$key = {
  readonly " $data"?: HpSharedEditorialModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedEditorialModule_componentModule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedEditorialModule_componentModule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "EditorialItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cta",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EditorialModule",
  "abstractKey": null
};
})();

(node as any).hash = "617f74652768d124e4d0e67f700e24bd";

export default node;
